import Axios from "axios";
import { useEffect, useReducer } from "react";
import { systemCode, xs_languageCode } from '..';
import { buildMenuData } from "./utils/buildMenuData";
import { dataFetchReducer } from "./utils/dataFetchReducer";
import { getConfiguration } from './utils/configuration';

export function useFetchPrematchMenu() {
    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
    });

    useEffect(() => {
        let didCancel = false;

        const fetchData = async (url, params, callback) => {
            dispatch({ type: 'FETCH_INIT' });
            try {
                const result = await Axios.get(url, {params});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    dispatch({ type: 'FETCH_FAILURE' });
                }
            }
        };
        
        const url = getConfiguration().api.getMenuPrematch;
        const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: '',
        };
        fetchData(url, params, function(response) {
            const parsedData = buildMenuData(response);
            if(parsedData){
                parsedData.nel = response.nel;
                parsedData.nep = response.nep;
            }
            dispatch({ type: 'FETCH_SUCCESS', payload: parsedData });
        });
        
        return () => {
            didCancel = true;
        };
    }, []);

    return [state, dispatch];
}
